import React, { FunctionComponent } from 'react';
import { ImageBlockModel } from '../../../../services/content/articleBody/models/ImageBlockModel';
import { ImageRatios } from '../../../../services/content/image/models/ImageModel';
import { getImageByCropRatio } from '../../../../services/content/image/ImageConfiguration';
import styles from './ImageBlock.module.scss';
import S365Picture from '../../../Image/S365Picture';

type Props = {
    imageBlock: ImageBlockModel;
    ratio?: ImageRatios;
};

enum ImageAlignment {
    LEFT = 'left',
    RIGHT = 'right',
    CENTER = 'center',
}

const createImageAlignmentStyle = (alignment: ImageAlignment) => {
    if (alignment === ImageAlignment.LEFT) {
        return 'text-md-start';
    }
    if (alignment === ImageAlignment.RIGHT) {
        return 'text-md-end';
    }
    if (alignment === ImageAlignment.CENTER) {
        return 'text-md-center';
    }
    return '';
};

export const ImageBlock: FunctionComponent<Props> = ({ imageBlock, ratio = ImageRatios.NONE }) => {
    if (imageBlock && imageBlock.data && imageBlock.data.preview) {
        const alignmentStyle = createImageAlignmentStyle(
            imageBlock.data.preview?.imageBlock.alignment as ImageAlignment,
        );
        const image = getImageByCropRatio(imageBlock.data.content, ratio);
        return (
            <div className={`mb-3 text-start ${styles.container} ${alignmentStyle}`}>
                <S365Picture
                    url={image}
                    alt={imageBlock?.data?.alt ?? imageBlock?.data?.preview?.imageBlock?.description ?? ''}
                    className={`mb-1 ${styles.image}`}
                />
                <div
                    className={`font-lato-400 text-muted d-flex flex-column flex-md-row flex-lg-row justify-content-start justify-content-md-between justify-content-lg-between`}>
                    <div>{getImageDescription(imageBlock)}</div>
                    <div>{getImageSource(imageBlock)}</div>
                </div>
            </div>
        );
    }

    return null;
};

const getImageDescription = (imageBlock: ImageBlockModel) => {
    if (imageBlock) {
        const imageBlockDescription = imageBlock.data.preview?.imageBlock.description;
        const imageDescription = imageBlock.data.content ? imageBlock.data.content.description : '';

        if (imageBlockDescription && imageBlockDescription.length > 0) {
            return imageBlockDescription;
        }

        if (imageDescription && imageDescription.length > 0) {
            return imageDescription;
        }
    }

    return '';
};

const getImageSource = (imageBlock: ImageBlockModel) => {
    if (imageBlock) {
        const imageBlockAuthors = imageBlock.data.preview?.imageBlock.authors;

        const imageAuthors = imageBlock.data.content ? imageBlock.data.content.authors : [];

        if (imageBlockAuthors && imageBlockAuthors.length > 0) {
            const authorNames = imageBlockAuthors.map((author) => author.name);
            return authorNames.join(', ');
        }

        if (imageAuthors && imageAuthors.length > 0) {
            const authorNames = imageAuthors.map((author) => author.name);
            return authorNames.join(', ');
        }

        if (imageBlock.data.content && imageBlock.data.content.origin) {
            return imageBlock.data.content.origin.name;
        }
    }
    return '';
};
